import React, { useState } from 'react';
import { DeviceType } from '../../../enum/EnumRepository';
import { useDeviceStore } from '../../../store/deviceStore';
import styled from 'styled-components';
import { paperTextureAlert } from '../../paperTexture';

interface HintSmallWrapperProps {
  children: React.ReactNode;
  content: string;
  toLeft?: boolean;
  toBottom?: boolean;
}

const HintSmallWrapper: React.FC<HintSmallWrapperProps> = ({
  children,
  content,
  toLeft,
  toBottom,
}) => {
  const { deviceType } = useDeviceStore();
  const [isHover, setIsHover] = useState(false);

  if (deviceType === DeviceType.MOBILE) {
    return <>{children}</>;
  }

  return (
    <HintHoverWrapper
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}>
      <HintCard $isHover={isHover} $toLeft={toLeft} $toBottom={toBottom}>
        {content}
      </HintCard>
      {children}
    </HintHoverWrapper>
  );
}

const HintHoverWrapper = styled.div`
  position: relative;
`;

const HintCard = styled.div<{
  $isHover: boolean;
  $toLeft?: boolean;
  $toBottom?: boolean;
}>`
  position: absolute;
  ${({ $toBottom }) => ($toBottom ? 'top: 20px;' : 'bottom: 20px;')}
  ${({ $toLeft }) => $toLeft && 'right: 0;'}
  width: fit-content;
  min-width: 40px;
  max-width: 300px;
  display: flex;
  align-items: center;
  padding: 0.4vw 0.6vw;
  
  white-space: nowrap;
  ${paperTextureAlert}
  ${({ theme }) => theme.typography.Body_04};

  /* Hover animations */
  opacity: ${({ $isHover }) => ($isHover ? 1 : 0)};
  transform: translateY(${({ $isHover }) => ($isHover ? '0' : '20px')});
  transition: opacity 0.3s ease, transform 0.3s ease;
  pointer-events: ${({ $isHover }) => ($isHover ? 'auto' : 'none')};
`;

export default HintSmallWrapper;
